window.Products.Clothing.PremiumUnisexTankTop = function() {
};
window.Products.Clothing.PremiumUnisexTankTop.inherits(window.Products.Clothing.Shirt);
window.Products.Clothing.PremiumUnisexTankTop.dpi = 150;
window.Products.Clothing.PremiumUnisexTankTop.has_3d = true;
window.Products.Clothing.PremiumUnisexTankTop.id = 107;
window.Products.Clothing.PremiumUnisexTankTop.slug = 'premium-unisex-tank-top';
window.Products.Clothing.PremiumUnisexTankTop.syncColors = true;
window.Products.Clothing.PremiumUnisexTankTop.texturesLoaded = 0;
window.Products.Clothing.PremiumUnisexTankTop.texturesLoading = false;
window.Products.Clothing.PremiumUnisexTankTop.use_glb = true;

window.Products.Clothing.PremiumUnisexTankTop.prototype.outsideObject = 0;
window.Products.Clothing.PremiumUnisexTankTop.prototype.position = 0.1;

window.Products.Clothing.PremiumUnisexTankTop.prototype.handleColorOption = function(modelViewer, color){
	var me = modelViewer.product;

	var object = modelViewer.object;
	if(!object) return;

	if(!color) {
		if(modelViewer.inlab){
			$('#button_options_color').find('img').attr('src', $(this).find('img').attr('src'));
			$('#container_options_color, #button_options_color').removeClass('active');
			color = $(this).attr('for');
		} else {
			color = $('#productInfo-productOption-color').find('option:selected').attr('data-slug');
		}
	}

	var three_color = me.getColor(color);
	//object.children[0].children[me.outsideObject].material.color = three_color;

	me.updateThreeTexture(modelViewer);

	object.children[me.outsideObject].material.aoMapIntensity = 1;
};

window.Products.Clothing.PremiumUnisexTankTop.prototype.getColor = function(_name){
	colors = {
		"white": 0xffffff,
		"black": 0x171616,
		"navy": 0x262840,
	};

	return new THREE.Color(colors[_name]);
};